enum PRODUCT_DOMAIN_TYPES {
  PRODUCT_LITE = 'PRODUCT_LITE',
  PRODUCT = 'PRODUCT',
  WEBSITE_PRODUCT = 'WEBSITE_PRODUCT',
}

export default PRODUCT_DOMAIN_TYPES
